function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.065 11.886a9.065 9.065 0 11-18.13 0 9.065 9.065 0 0118.13 0zm-2 0a7.065 7.065 0 11-14.13 0 7.065 7.065 0 0114.13 0z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 20.95h1v2.55h2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2v2a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-2h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2v-2.55h1z",
  fill: "currentColor"
})));